import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Area as RCArea } from 'recharts'
import { store } from '../../../../app/store'
import { selectChartData, setChartData } from '../store'

class Area extends RCArea {
  constructor(props) {
    super(props)
    this.state = { isActive: true }

    this.setIsActive = this.setIsActive.bind(this)
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.renderDot = this.renderDot.bind(this)
  }

  setIsActive(active) {
    if (active !== this.state.isActive) {
      this.setState({ isActive: active })
    }
  }

  onMouseOver(isHoverDot) {
    if (!this.props.chartId) return
    store.dispatch(
      setChartData({
        chartId: this.props.chartId,
        activeKey: this.props.dataKey,
        activeTooltip: this.props.onlyActiveTooltipOnHoverDot
          ? isHoverDot
          : true,
      }),
    )
  }

  onMouseLeave() {
    if (!this.props.chartId) return
    store.dispatch(
      setChartData({
        chartId: this.props.chartId,
        activeKey: undefined,
        activeTooltip: false,
      }),
    )
  }

  renderDot(defaultDot, dot) {
    const { cx, cy, opacity } = defaultDot

    if (!dot || typeof cx !== 'number' || typeof cy !== 'number') return

    return (
      <circle
        key={cx}
        cx={cx}
        cy={cy}
        r={3}
        opacity={opacity}
        onMouseOver={() => this.onMouseOver(true)}
        onMouseLeave={this.onMouseLeave}
        {...dot}
      />
    )
  }

  render() {
    const { children, dot, ...rest } = this.props

    return (
      <>
        <RCArea
          onMouseOver={() => this.onMouseOver(false)}
          onMouseLeave={this.onMouseLeave}
          opacity={this.state.isActive ? 1 : 0.4}
          dot={(defaultDot) => this.renderDot(defaultDot, dot)}
          {...rest}
        >
          {children}
        </RCArea>
        <g>
          <foreignObject>
            <ListenData
              chartId={this.props.chartId}
              dataKey={this.props.dataKey}
              setIsActive={this.setIsActive}
            />
          </foreignObject>
        </g>
      </>
    )
  }
}

const ListenData = ({ chartId, dataKey, setIsActive }) => {
  const activeKey = useSelector(
    selectChartData(chartId, (data) => data.activeKey),
  )

  useEffect(() => {
    const active = !activeKey || (activeKey && activeKey === dataKey)
    setIsActive(active)
  }, [activeKey, dataKey, setIsActive])

  return <></>
}

Area.propTypes = {
  onlyActiveTooltipOnHoverDot: PropTypes.bool,
  // All rechart tooltip content props
}

Area.defaultProps = {
  ...RCArea.defaultProps,
  stroke: 'none',
  dot: {},
  activeDot: false,
  isAnimationActive: false,
  onlyActiveTooltipOnHoverDot: true,
}

export default Area
